import request from '@/utils/request';

// 获取列表
export function List(params) {
    return request({
        url: params.type == 'detail' ? '/adapt/report/getBindingListByPara' : '/adapt/report/getBindingList',
        method: 'GET',
        params: params
    });
}